export default "__VITE_ASSET__7135df2a__"